


document.addEventListener("DOMContentLoaded", (event) => {

  
  $('.choices').not(':first').hide();
  if($('#conditions-options').index() != 0){
  $('#conditions-options .conditions').hide();
  }
  $('.option-section .option-title').on('click', function() {
      const ele = $(this);
      const choices = ele.parent().find('.choices');

      // Show the element if it's hidden, otherwise hide it
      if (choices.is(':visible')) {
          choices.fadeOut(200); // Hide
          choices.parents('.option-section').removeClass('active-drop');
      } else {
          choices.fadeIn(200); // Show
          choices.parents('.option-section').addClass('active-drop');
      }
  });


 
  $(document).on('click','.goback', function(){
      const prevStep  = $(this).data("goto");
    $("#step-1,#step-2,#step-3").removeClass("show");
    $("#step-1,#step-2,#step-3").addClass("hidden");
    $("#step-"+prevStep).addClass("show");
  })

  $(document).on('click', '.choices .choice input', async function(e) {
      try {
          let ele = $(this);
          let selectedOption = ele.next('label').text();
          ele.parents('.option-section').find('.selected-option').text($.trim(selectedOption));
          ele.parents('.option-section').addClass("option-selected");
          ele.parents('.option-section').next('.option-section').addClass('active active-drop');
          ele.parents('.option-section').next('.option-section').find('.choices, .conditions').fadeIn(200);
          let response = await getProductCondition();
          let result = response.data.result;
          const conditionDiv = $("#conditions-options");
          const productConditions = result.conditions;
          let choiceHtml = "";
          let terms = "";
          let productId = result.product.product_id;
          productConditions.forEach((condition, index) => {
              choiceHtml += `
            <div class="choice">
                <input type="radio" data-name="${condition.name}" name="condition" data-id="${condition.id}" data-price="${condition.price}" value="${condition.id}" id="conditions-${index}">
                <label for="conditions-${index}">
                    ${condition.name}
                </label>
            </div>`;
              terms += `<div id="condition_${condition.id}" style="display:none">
                        <h7 class="term_title">${condition.terms.title}</h7>
                        <ul>
                          ${condition.terms.content.map(item => `<li>${item}</li>`).join('')}
                        </ul>
                      </div>`;
          });
          conditionDiv.find(".conditions").html(choiceHtml);
          $('.template-reusely').data('productid',productId);
          $('.selected_term').html(terms);
          $(".sell_item").html("");
      } catch (err) {
          console.error('Error handling click:', err);
      }
  });

  // get spec

  async function getProductCondition(formData) {
      var formData = $("#product-spec").serialize();
      let result = null;
      let url = "https://reusely-api.onrender.com";
      // let url = "https://fc18-38-183-9-254.ngrok-free.app";

      const response = await fetch(url + "/api/product/condition?" + formData);
      if (response.ok) {
          result = await response.json();
      }
      return result;

  }



  $(document).on('click', '#conditions-options .conditions .choice input', function() {
      let conditionid = $(this).data('id');
      let price = $(this).data('price');
      let sell_item = "";
      sell_item += `<div class="sell-container">
                    <div class="money-info">
                      <label for="email">Email Address<span>*</span></label>
                      <input type="email" name="email" id="customer_email" placeholder="your@email.com"/>
                    </div>
                    <div class="sell-btn">
                    <button type="button" class="btn-cutom sell-item btn-loading">Get My Price</button>
                    </div>
          </div>`;
          $(".selected_term div").css("display", "none");
          $("#condition_" + conditionid).css("display", "block");
          $(".sell_item").html(sell_item);
     
  });

  // customer reviews 
  var elem = document.querySelector('.customer-reviews-reusely');
  if (elem) {
  var flkty = new Flickity( elem, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      autoPlay: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: true,
      pageDots: false,
      resize: true
  });
}

  $(document).on('click','.sell-item', function(e){
    e.preventDefault();
    let ele = $("#customer_email");

    ele.removeClass("is-invalid");
    
    let customerEmail = ele.val();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    $(this).text("");
    buttonAnimation($(this),'show');    
    if(customerEmail==""){
      ele.addClass("is-invalid");
      buttonAnimation($(this),'hide');  
      $(this).text("Get My Price");
      return false;
    }
    if(!regex.test(customerEmail)){
        ele.addClass("is-invalid");
        buttonAnimation($(this),'hide');  
        $(this).text("Get My Price");
        return false;
     }
    localStorage.setItem("offer_email", customerEmail);
    let condition = $('input[name="condition"]:checked').data('id');
    let productId = $('.template-reusely').data('productid');
    window.location.href = 'checkout/'+productId+'/'+condition;
  });


  function updatePrice(qty){
    let basePrice = parseFloat($('.item-price .price span').text());
    let totalAmount = $('.total-payable-amount .totalprice')
    let updatedPrice = basePrice*qty;
    totalAmount.text(updatedPrice.toFixed(2));
    
  }

  
  // quantity update
$(document).on('click', '.quantity-container a', function() {
  let ele = $(this);
  let type = ele.data('type');
  let qtyElement = $('.qty[type="number"]');
  let qty = parseInt(qtyElement.val()); 
  if (type === 'minus') {
    if (qty > 1) {
      qty--;
    }
  } else {
    qty++;
  }
  qtyElement.val(qty); 
  updatePrice(qty);
});

  async function getInMailPayouts(){
    let result = null;
      let url = "https://reusely-api.onrender.com";
      // let url = "https://fc18-38-183-9-254.ngrok-free.app";

      const response = await fetch(url + "/api/payout/methods");
      if (response.ok) {
          result = await response.json();
      }
      return result;
  } 


  $(document).on('click','.total-payable-amount', function(){
    $("body").addClass("poup-overlay");
    $("#step-1").removeClass("hidden");
    $("#step-1").addClass("show");
    const offerEmail = localStorage.getItem("offer_email");
    $("#email").val(offerEmail);

  })

  $(document).on("click",'.popup-container .close', function(){
    $elem = $(this).parents(".popup-container");
    $("body").removeClass("poup-overlay");
    $elem.addClass('hidden');
    $elem.removeClass('show');
  })

  function buttonAnimation(ele, property){
    if(property=='show')
    {
      ele.addClass('animation');
      ele.prop('disabled' , true);
    } else {
       ele.removeClass('animation');
       ele.prop('disabled' , false);
    }
  }
  
  $(document).on('click','.getpayouts', async function(){
    // check email validation 
    let errorEle = $('#step-1 .error');
    let email = $('#step-1 [type="email"]').val();
    let firstName = $('#step-1 #firstname').val();
    let lastName = $('#step-1 #lastname').val();
     errorEle.text("");

     $('#step-1 [type="email"], #step-1 #firstname, #step-1 #lastname').removeClass("is-invalid");
     
    
     buttonAnimation($(this),'show');    
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(email == "" && firstName == "" && lastName == ""){
      //errorEle.text("All fields are required.");
      $('#step-1 [type="email"]').addClass("is-invalid");
      $('#step-1 #firstname').addClass("is-invalid");
      $('#step-1 #lastname').addClass("is-invalid");

      buttonAnimation($(this),'hide');    
      
      return false;
    }
    if(email == ""){
      buttonAnimation($(this),'hide');  
      return false;
    }

     if(!regex.test(email)){
        buttonAnimation($(this),'hide');  
        return false;
     }
    
     const response = await getInMailPayouts();
     const payouts = response.data.result;
     // Initialize an empty string for the HTML content
    let methodHtml = "";
    let methodAttributesHtml = "";

    // Loop through each method and create HTML dynamically
    payouts.forEach(function(method) {
      if(method.name=="Bank Transfer")
      // methodHtml += `
      //   <div class="payment-method" data-payoutmode="${method.name}" data-paymentid="${method.id}">
      //     <h3>${method.name}</h3>
      //     <img src="${method.icon}" alt="${method.name} icon">
      // </div>`;

      // Add attributes (if any)
      if (method.attributes.length > 0) {
        methodAttributesHtml += `<form data-paymentAttr="${method.id}">`;
        method.attributes.forEach(function(attribute) {
          methodAttributesHtml += `
            <div class="attribute">
              <label for="${attribute?.name ?? attribute}">${attribute?.name ?? attribute} <span class="required">*</span></label>
              <input type="text" id="${attribute?.attribute_name ?? attribute}" name="${attribute?.attribute_name ?? attribute}" required placeholder="${attribute?.attribute_name ?? attribute}">
            </div>
          `;
        });
        methodAttributesHtml += `</form>`;
      }
    });

    // Append the generated HTML to the container
    $('.payout-options').html(methodHtml);
    $('.payout-attributes').html(methodAttributesHtml);
    buttonAnimation($(this),'hide');  
    //Fancybox.close();
    $("body").addClass("poup-overlay");
    $("#step-3").removeClass("hidden");
     $("#step-1").removeClass("show");
    $("#step-1").addClass("hidden");
    $("#step-3").addClass("show");    
  })

  $(document).on('click','.payment-method', function(){

    let error = $('#step-2 .error');
    error.text("");
    
    $('.payment-method').removeClass('selectedPayout');
    $(this).addClass('selectedPayout');
    let paymentId = $(this).data('paymentid');
    $('.payout-attributes form').css('display','none');
    $('.payout-attributes [data-paymentattr="'+paymentId+'"]').css('display','block');
  });


  function validatePayout(){
    let payoutmode = $('.selectedPayout').data('payoutmode');
    let error = $('#step-2 .error');

    error.text("");
    
    if(payoutmode == 'Bank Transfer'){
      let account_name = $('#account_name').val();
      let sort_code = $('#sort_code').val();
      let account_number = $('#account_number').val();
      if(account_name =="" || sort_code == "" || account_number == ""){
        error.text("All fields are required.");
        return false;
      }
    }else if(payoutmode == "PayPal"){
      let paypal_address = $("#paypal_address").val();
      if(paypal_address == ""){
         error.text("PayPay Email or Phone number required.");
        return false;
      }
    }
    return true;
  }
  
  
   $(document).on('click','.getAccount', function(){

    const address = $('#step-3 [name="address"');
    const city = $('#step-3 [name="city"');
    const state = $('#step-3 [name="state"');
    const postalcode = $('#step-3 [name="postalcode"');

     buttonAnimation($(this),'show');  

      address.removeClass("is-invalid");
      city.removeClass("is-invalid");
      state.removeClass("is-invalid");
      postalcode.removeClass("is-invalid");
    

    if(address.val() == "" && city.val() == "" && state.val() == "" && postalcode.val() == ""){
      address.addClass("is-invalid");
      city.addClass("is-invalid");
      state.addClass("is-invalid");
      postalcode.addClass("is-invalid");
      buttonAnimation($(this),'hide');  
      return false;
    } 

    if(address.val() == ""){
      address.addClass("is-invalid");
      buttonAnimation($(this),'hide');
      return false;
    }

    if(city.val() == ""){
      city.addClass("is-invalid");
      buttonAnimation($(this),'hide');
       return false;
      
    }

    if(state.val() == ""){
      state.addClass("is-invalid");
      buttonAnimation($(this),'hide');
       return false;
    }

    if(postalcode.val() == ""){
      buttonAnimation($(this),'hide');
      postalcode.addClass("is-invalid");
       return false;
    }
    buttonAnimation($(this),'hide');

     $("body").addClass("poup-overlay");
    $("#step-2").removeClass("hidden");
    $("#step-3").removeClass("show");
    $("#step-3").addClass("hidden");
    $("#step-2").addClass("show");
     
  });


  // create order request 

    async function createOffer(cartData) {
      let result = null;
      let url = "https://reusely-api.onrender.com";
      
      const response = await fetch(url + "/api/checkout/mail-in-offer",{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
      });
      // if (response.ok) {
          result = await response.json();
      // }else{
      //   error = await response.json();
      //   $("#step-2 .error").text()
      // }
      return result;

  }

  $(document).on('click','.getOffer', async function(){

    buttonAnimation($(this),'show');
    
    const account_name_ele = $("#account_name");
    const sort_code_ele = $("#sort_code");
    const account_number_ele = $("#account_number");

    if(account_name_ele.val() == "" && sort_code_ele.val() == "" && account_number_ele.val() == ""){
      account_name_ele.addClass("is-invalid");
      sort_code_ele.addClass("is-invalid");
      account_number_ele.addClass("is-invalid");
      buttonAnimation($(this),'hide');
      return false;
    }

    if(account_name_ele.val() == ""){
      account_name_ele.addClass("is-invalid");
      buttonAnimation($(this),'hide');
      return false;
    }

    if(sort_code_ele.val() == ""){
      sort_code_ele.addClass("is-invalid");
      buttonAnimation($(this),'hide');
      return false;
    }

    if(account_number_ele.val() == ""){
      account_number_ele.addClass("is-invalid");
       buttonAnimation($(this),'hide');
      return false;
    }
    
    
    
    const url  = window.location.href;
    const parts = url.split('/');
    const producttid = parts[parts.length - 2];
    const condition = parts[parts.length - 1];
    const customer_email = $("#email").val();
    const shipping_firstname = $("#firstname").val();
    const shipping_lastname  = $("#lastname").val();
    const shipping_address1 = $('input[name="address"]').val();
    const shipping_city = $('input[name="city"]').val();
    const shipping_state = $('input[name="state"]').val();
    const shipping_zip = $('input[name="postalcode"]').val();
    const offer_detail = [{product_id:producttid, condition_id:condition, description:"",qty:$('[type="number"].qty').val(),notes:""}];
    const payout_method = "Bank Transfer";
    const account_name =$('#account_name').val();
    const sort_code  = $('#sort_code').val();
    const account_number = $('#account_number').val(); 
    const response = await createOffer({customer_email,shipping_firstname,shipping_lastname, shipping_address1, shipping_city, shipping_state, shipping_zip, offer_detail, payout_method, account_name, sort_code, account_number});
    
    if(response.data.status_code !== 201){
      $("#step-2 .error").text(response.message);
      return false;
    }
    //$(".sucess-loader").append('<div class="loader-inner"><div class="inner-loader-text"><h2>Offer locked. Thank you!</h2></div></div>');
    const orderLink = "https://customerportal.tech4cash.com/"+response.data.result.box_id+"?company_token="+response.data.result.company_token+"&token="+response.data.result.token;
    setTimeout(function(){
      buttonAnimation($(this),'hide');
      window.location.href = orderLink;
    },2000);
  })


  function startTimer(){
  let duration = 10 * 60; // 10 minutes in seconds
  const display = $('.timer');

   timer = setInterval(function () {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;

    display.text(
      `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    );

    if (--duration < 0) {
      clearInterval(timer);
      //display.text('Time’s up!');
    }
  }, 500);
  }


  
}); // dom content loaded end

  
